/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * A single environment entry
 */
export type EnvironmentEntry = {
  /**
   * The creation date of the environment entry
   */
  createdAt: Date;
  /**
   * Whether the value is a secret. Secret values are redacted in reads; non-secret values are returned in cleartext.
   */
  isSecret: boolean;
  /**
   * The name of the environment variable
   */
  name: string;
  /**
   * When the environment entry was last updated
   */
  updatedAt: Date;
  /**
   * The value of the environment variable. Cleartext when is_secret is false, redacted otherwise.
   */
  value: string;
};

/** @internal */
export const EnvironmentEntry$inboundSchema: z.ZodMiniType<
  EnvironmentEntry,
  unknown
> = z.pipe(
  z.object({
    created_at: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
    is_secret: z.boolean(),
    name: z.string(),
    updated_at: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
    value: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "created_at": "createdAt",
      "is_secret": "isSecret",
      "updated_at": "updatedAt",
    });
  }),
);

export function environmentEntryFromJSON(
  jsonString: string,
): SafeParseResult<EnvironmentEntry, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => EnvironmentEntry$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'EnvironmentEntry' from JSON`,
  );
}
